module.exports = __webpack_public_path__ + "img/tutorial_main_01.cb3bda68.jpg";